import { Box, Container, Typography } from "@mui/material";
import moment from "moment";
import { useParams } from "react-router";
import CommCard from "src/common/CommCard";
import CommonPdfAndImageView from "src/common/CommonPdfAndImageView";
import DetailsDataShowByGrid from "src/common/DetailsDataShowByGrid";
import GoBackBtn from "src/common/GoBackBtn";
import GlobalLoader from "src/components/SuspenseLoader/GlobalLoader";
import { useApiQuery } from "src/hooks/useApiQuery";
import type { TB2BData } from "../type/b2bType";
import SingleB2BOtherInformation from "./SingleB2BOtherInformation";
import EditCommIcon from "src/common/EditCommIcon";
import { useState } from "react";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import ApprovedSingleb2b from "./ApprovedSingleb2b";
import { getStatusLabel } from "src/Utils/Combined";

const SingleB2B = () => {
	const { singleB2BId } = useParams();
	const [open, setOpen] = useState(false);
	const { data, isLoading } = useApiQuery<TB2BData>({
		endPoint: `/api/fair/admin/b2b/${singleB2BId}`,
		queryKeys: ["b2b_details", singleB2BId],
	});

	return (
		<div>
			<CommCard helmetTitle='BTTF - B2B Information'>
				<GoBackBtn showGoBack />
				<EditCommIcon handleClick={() => setOpen(!open)} />
				{!isLoading ? (
					<Container maxWidth='xl' sx={{ pb: 1, pt: 0 }}>
						<Typography
							textAlign='center'
							variant='h4'
							component='h2'
							sx={{ mb: 1.5, fontWeight: 700, fontSize: "1.25rem", color: "#1E293B" }}
						>
							{data?.b2b_type === "Buyer"
								? "Buyer B2B Information"
								: data?.b2b_type === "Seller"
									? "Seller B2B Information"
									: "Buyer/Seller B2B Information"}
						</Typography>

						<Box sx={{ textAlign: "start", mb: 1.5 }}>
							<CommonPdfAndImageView
								fileName='View Company Logo'
								file={data?.b2b_photo}
							/>
						</Box>
						<DetailsDataShowByGrid
							fields={[
								{
									label: "First Name",
									value: data?.b2b_first_name || "N/A",
								},
								{
									label: "Last Name",
									value: data?.b2b_last_name || "N/A",
								},
								{
									label: "Email",
									value: data?.b2b_email || "N/A",
								},
								{
									label: "Country",
									value: data?.b2b_country || "N/A",
								},
								{
									label: "Phone",
									value: data?.b2b_phone || "N/A",
								},

								{
									label: "Created Date",
									value: data?.b2b_created_at
										? moment(data.b2b_created_at).format(
											"LL"
										)
										: "N/A",
								},
								{
									label: "Company Brief",
									value: data?.b2b_company_brief || "N/A",
								},
								{
									label: "Organization",
									value: data?.b2b_organization || "N/A",
								},
								{
									label: "Designation",
									value: data?.b2b_designation || "N/A",
								},
								{
									label: "Website",
									value: data?.b2b_website || "N/A",
								},
								{
									label: "Address",
									value: data?.b2b_address || "N/A",
								},
								{
									label: "Status",
									value:
										getStatusLabel(data?.b2b_status) ||
										"N/A",
								},
								{
									label: "Telephone Number",
									value: data?.b2b_telephone_number || "N/A",
								},
								{
									label: "Type",
									value: data?.b2b_type || "N/A",
								},
								{
									label: "Business Type",
									value: data?.b2b_business_type || "N/A",
								},
								{
									label: "ID Type",
									value: data?.b2b_id_type || "N/A",
								},
								{
									label: "ID Number",
									value: data?.b2b_id_number || "N/A",
								},
								{
									label: "Intention",
									value: data?.b2b_intention || "N/A",
								},
								{
									label: "Join Year",
									value: data?.b2b_join_year
										? String(data.b2b_join_year)
										: "N/A",
								},

								,

								...(data?.b2b_locations
									?.filter(
										(item) =>
											item?.location_type === "country"
									)
									?.map((item) => ({
										label: "Country(Continent)",
										value: item?.location_name,
									})) || []),
							]}
						/>

						<SingleB2BOtherInformation
							loading={isLoading}
							b2bDetails={data}
						/>
					</Container>
				) : (
					<GlobalLoader />
				)}
			</CommCard>

			<ModalsWrapper
				showModal={open}
				modalData={{ title: "Update B2B Status" }}
				setShowModal={setOpen}
			>
				<ApprovedSingleb2b handleClose={() => setOpen(false)} />
			</ModalsWrapper>
		</div>
	);
};

export default SingleB2B;
